import React, { useEffect, useState } from 'react';
import './App.css';
import Navbar from './navbar';
import { useNavigate } from 'react-router-dom';


 
//Component for personal details
export default function Person () {
  
  const API_URL = process.env.REACT_APP_WEB_API_KEY;
  const navigate = useNavigate();
  const [Customer, setCustomer] = useState([]);


  useEffect(()=>
  {
     fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
    .then(res=>res.json())
    .then((data)=>{setCustomer(data)})
  },[])
  
  function addcustomer()
  {
      var customerid = Customer[0].CustomerID + 1 ;
      var cusName = document.getElementById("cusName").value.toUpperCase();
      var fatName = document.getElementById("fatName").value;
      var gen = document.getElementById("gen").value;
      var addRess = document.getElementById("addRess").value;
      var city = document.getElementById("city").value;              
      var disTrict = document.getElementById("disTrict").value;
      var mNumber = document.getElementById("mNumber").value;
      var office = document.getElementById("office").value;
      var offAdrs = document.getElementById("offAdrs").value;
      var offPhone = document.getElementById("offPhone").value;      
      const data = new FormData();
      data.append("customerid",customerid)
      data.append("cusName",cusName);
      data.append("fatName",fatName);
      data.append("gen",gen);
      data.append("addRess",addRess);
      data.append("city",city);
      data.append("disTrict",disTrict);
      data.append("mNumber",mNumber);
      data.append("office",office);
      data.append("offAdrs",offAdrs);
      data.append("offPhone",offPhone);

    fetch(API_URL+"api/Customer/CreateCustomer",{method:"POST",body:data})
    .then(res=>res.json())
    .then(()=>{})
    
    fetch(API_URL+"api/Customer/IncrementCustomerID?id=" + customerid,{method:"PUT",body:null})
    .then(res=>res.json())
    .then(()=>{})

    showOKdialog();


     }
     
     function validate(){
          if(document.getElementById('cusName').value ==='' || document.getElementById('fatName').value === ''||
          document.getElementById('addRess').value===''|| document.getElementById('city').value==='' ||
          document.getElementById('disTrict').value===''||document.getElementById('mNumber').value==='')
          {
            alert("Feilds Cannot be empty"); 
          } 
          else
          {
            if((document.getElementById('mNumber').value.length !== 10))
            {
             alert("Mobile number Should be 10 Digit ");
            }
            else
            {
             return true;
            }
          }
     }

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.show();
}
  return ( 
          
        <>
    <div style={{backgroundColor:"blue", color:"white", height:"30px", width:"100%", 
    paddingTop:"10px", top :"0px", position:"relative", 
    fontFamily:"sans-serif",fontSize:"18px"}}> 
            Customers
            <Navbar/>
    </div>      
     <div style={{backgroundColor:"goldenrod",height:"25px",width:"100%",textAlign:"center"}}>New Customer</div>
    
    {/*Heading End */}
    {/*Customer Dialogue Start */}
    
    <div style = {{top:"10px", position:"relative",color:"black",  padding:-1, width:"100%"}}>
      <form>
    <fieldset>
      <legend>Personal Info</legend>
      
      {/* <label for = "idNum">Customer ID</label><br /> */}
      {/* <input type = "text" id = "idNum" style = {{height:"30px",width:"100%"}}  ></input><br/> <br/> */}
      
      <label for = "cusName" >Name </label> <br/>
      <input type = "text" id='cusName'  className='inputfield'  ></input><br/> <br/>
      
      <label for = "fatName" > Father Name</label><br/>
      <input type = "text" id = 'fatName'  className='inputfield' ></input><br/> <br/>
     
      <label for = "gen" >Gender </label> <br/>
      <select id = "gen" name='gender' className='inputfield'>
        <option value = "Male">Male</option>
        <option value = "Female" >Female</option>
      </select> <br /><br/>
      
      <label for = "addRess" > Address</label><br/>
      <input type = "text" id='addRess'  className='inputfield' ></input><br/> <br/>
      
      <label for = "city" > City </label> <br/>
      <input type = "text" id='city'  className='inputfield'></input><br/> <br/>
      
      <label for = "disTrict" > District </label><br/>
      <input type = "text" id = 'disTrict'  className='inputfield' ></input><br/><br/>
      
      <label for = "mNumber" > Mobile No</label><br/>
      <input type = "text" id = 'mNumber'  className='inputfield' ></input><br/> <br/>
      
    </fieldset>
    <fieldset style={{marginBottom:"10%"}}>
      <legend>Office Info</legend>
      <label for ="office">Office</label><br />
      <input type='text' id='office'  defaultValue="-" className='inputfield'></input><br/><br/>
      <label for = "offAdrs" >Office Address</label><br />
      <textarea id="offAdrs" name='OAddress' defaultValue="-" rows="5"  style={{width:"100%"}}></textarea><br/>
      <label for = "offPhone">Phone</label><br/>
      <input type = "text" id="offPhone" defaultValue="0" className='inputfield'></input><br/><br/>
      
      <div >
      
      <button type = "button"  className='actionbuttons' onClick={()=>{if(validate()){addcustomer();}}}>Register</button> 
      <button type = "button"  className='actionbuttons' style ={{backgroundColor:"red"}} onClick={()=>{navigate('/home')}}>Cancel</button>
      </div>
      </fieldset>
      </form>
      <dialog id="myDialog" className="okdialog"><p>Customer Registration Successful</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button>
      </dialog>
    </div>
    </>
  
    
  ); 
  }
 





